import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { analyticsConfigured, contextForPath, loadAnalytics, track, whatsappLink, quoteLink } from "@/lib/site";
import { WhatsAppIcon } from "./Primitives";


export function ConversionDock() {
  const { pathname } = useLocation();
  const ctx = contextForPath(pathname);
  const hideQuote = pathname === "/contact";
  return (
    <>
      {/* Sticky mobile CTA bar */}
      <div className="fixed inset-x-0 bottom-0 z-40 border-t border-black/10 bg-white px-3 pb-[max(0.5rem,env(safe-area-inset-bottom))] pt-2 shadow-[0_-8px_24px_rgba(0,0,0,0.06)] md:hidden" data-testid="sticky-mobile-cta-bar">
        <div className="flex gap-2">
          {!hideQuote && (
            <Link to={quoteLink({ category: ctx.category, type: ctx.type })} onClick={() => track("quote_cta_click", { label: "sticky_mobile" })} className="kl-btn kl-btn-dark h-12 flex-1 px-3 text-[14px]" data-testid="sticky-mobile-quote-button">
              Request a Quote
            </Link>
          )}
          <a href={whatsappLink(ctx.msg)} target="_blank" rel="noopener noreferrer" onClick={() => track("whatsapp_click", { label: `sticky_${ctx.msg}` })} className="kl-btn kl-btn-outline h-12 flex-1 px-3 text-[14px]" data-testid="sticky-mobile-whatsapp-button" aria-label="WhatsApp KhozaLand (opens in a new tab)">
            <WhatsAppIcon /> WhatsApp
          </a>
        </div>
      </div>
      {/* Floating WhatsApp (tablet/desktop) */}
      <a
        href={whatsappLink(ctx.msg)}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => track("whatsapp_click", { label: `floating_${ctx.msg}` })}
        className="fixed bottom-6 right-6 z-40 hidden items-center gap-2 rounded-full border border-black/10 bg-[#161616] py-3 pl-4 pr-5 text-sm font-semibold text-white shadow-[0_14px_40px_rgba(0,0,0,0.25)] transition-transform duration-200 hover:-translate-y-0.5 md:inline-flex"
        data-testid="floating-whatsapp-button"
        aria-label="WhatsApp KhozaLand (opens in a new tab)"
      >
        <WhatsAppIcon className="h-5 w-5" /> WhatsApp us
      </a>
    </>
  );
}

const CONSENT_KEY = "kl_analytics_consent";

// Only shown when an analytics ID is configured (POPIA: no tracking scripts before consent).
export function ConsentBanner() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    if (!analyticsConfigured()) return;
    const v = localStorage.getItem(CONSENT_KEY);
    if (v === "granted") loadAnalytics();
    else if (!v) setVisible(true);
  }, []);
  if (!visible) return null;
  const decide = (granted) => {
    localStorage.setItem(CONSENT_KEY, granted ? "granted" : "denied");
    if (granted) loadAnalytics();
    setVisible(false);
  };
  return (
    <div role="region" aria-label="Cookie consent" className="fixed inset-x-3 bottom-20 z-50 rounded-[14px] border border-black/10 bg-white p-4 shadow-[0_18px_50px_rgba(0,0,0,0.15)] md:inset-x-auto md:bottom-6 md:left-6 md:max-w-md" data-testid="cookie-consent-banner">
      <p className="text-sm leading-6 text-black/75">We use optional analytics cookies to understand how visitors use our website. See our <Link to="/privacy-policy" className="underline underline-offset-4">Privacy Policy</Link>.</p>
      <div className="mt-3 flex gap-2">
        <button type="button" onClick={() => decide(true)} className="kl-btn kl-btn-dark h-10 px-4 text-sm" data-testid="cookie-consent-accept-button">Accept</button>
        <button type="button" onClick={() => decide(false)} className="kl-btn kl-btn-outline h-10 px-4 text-sm" data-testid="cookie-consent-decline-button">Decline</button>
      </div>
    </div>
  );
}
